import addition from './assets/images/services/addition.jpg'
import addition2 from './assets/images/services/addition2.jpg'
import concreteFinishing from './assets/images/services/concrete-finishing.jpg'
import concreteFinishing2 from './assets/images/services/concrete-finishing2.webp'
import deck from './assets/images/services/deck.jpg'
import deck2 from './assets/images/services/deck2.jpg'
import finishing from './assets/images/services/finishing.jpg'
import finishing2 from './assets/images/services/finishing2.jpg'
import formwork from './assets/images/services/formwork.avif'
import formwork2 from './assets/images/services/formwork2.jpg'
import framing from './assets/images/services/framing.jpg'
import framing2 from './assets/images/services/framing2.jpg'
import renovations from './assets/images/services/renovations.jpg'
import renovations2 from './assets/images/services/renovations2.jpg'
import siding from './assets/images/services/siding.jpg'
import siding2 from './assets/images/services/siding2.jpeg'

export const projects = [
    {
        id: 'siding',
        img: siding2,
        cover: siding,
        title: 'Siding',
        intro: 'Protective and stylish finishes',
        details:
            'Enhance your home’s curb appeal with durable, weather-resistant siding. We ensure a clean finish that protects your property while adding lasting style.',
        points: [
            'Careful removal of old siding when necessary.',
            'Proper preparation and weatherproofing of exterior walls.',
            'Installation of siding materials (vinyl, wood, fiber cement, or composite).',
            'Attention to detail on trim, joints, and sealing for long-lasting performance.',
        ],
    },

    {
        id: 'renovations',
        img: renovations,
        cover: renovations2,
        title: 'Renovations',
        intro: 'Fresh and functional upgrades',
        details:
            'Transform your space with thoughtful renovations. From layout changes to modern upgrades, we bring new life to existing homes.',
        points: [
            'Kitchen and bathroom upgrades.',
            'Wall reconfigurations for open-concept layouts.',
            'Flooring, drywall, and painting improvements.',
            'Energy-efficient upgrades and modern finishes.',
        ],
    },

    {
        id: 'additions',
        img: addition,
        cover: addition2,
        title: 'Additions',
        intro: 'Seamless home expansions',
        details:
            'Expand your living space seamlessly with custom additions. Our work blends new structures with your existing home for a natural, polished look.',
        points: [
            'Foundation preparation and structural framing.',
            'Integration with your existing electrical, plumbing, and HVAC systems.',
            'Roofing and siding to match your home’s exterior.',
            'Finishing work for a cohesive interior look.',
        ],
    },

    {
        id: 'framing',
        img: framing,
        cover: framing2,
        title: 'Framing',
        intro: 'Strong and precise structure',
        details:
            'Strong, precise framing is the backbone of every project. We build with accuracy and care to create a structure that lasts.',
        points: [
            'Layout planning and material preparation.',
            'Wall, floor, and roof framing with precise measurements.',
            'Use of quality lumber and fasteners.',
            'Collaboration with engineers and architects for compliance and safety.',
        ],
    },

    {
        id: 'finishing',
        img: finishing,
        cover: finishing2,
        title: 'Finishing',
        intro: 'Clean and polished details',
        details:
            'Bring your interiors to life with detailed finishing work. From trim to custom cabinetry, our craftsmanship delivers a polished touch.',
        points: [
            'Baseboards, crown molding, and trim installation.',
            'Custom cabinetry and shelving.',
            'Door and window casings.',
            'Interior painting and surface detailing.',
        ],
    },

    {
        id: 'formwork',
        img: formwork,
        cover: formwork2,
        title: 'Formwork',
        intro: 'Solid foundation support',
        details:
            'Reliable formwork sets the stage for concrete done right. We design and build forms that ensure accuracy, strength, and clean results.',
        points: [
            'Custom form designs for slabs, walls, and foundations.',
            'Use of durable materials to withstand pressure and ensure accuracy.',
            'Careful bracing and alignment to maintain form integrity.',
            'Safe and efficient removal once concrete sets.',
        ],
    },

    {
        id: 'decks',
        img: deck,
        cover: deck2,
        title: 'Decks',
        intro: 'Outdoor living, reimagined',
        details:
            'Elevate your outdoor living with a custom deck. We design and build structures that are both beautiful and built to last.',
        points: [
            'Design tailored to your space and lifestyle.',
            'Use of pressure-treated lumber, cedar, or composite materials.',
            'Structural framing for safety and longevity.',
            'Railings, stairs, and finishing touches to complete the look.',
        ],
    },
]
